/* NL Friends — live name search across all friends sections on the page */
(function(){
  if(window.__nlFriends) return; window.__nlFriends = true;
  function ready(fn){ document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',fn) : fn(); }
  ready(function(){
    var input = document.querySelector('[data-fr-search]');
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-fr-item]'));
    var count = document.querySelector('[data-fr-count]');
    var empty = document.querySelector('[data-fr-empty]');
    function run(){
      var q = (input ? input.value : '').trim().toLowerCase(), n = 0;
      items.forEach(function(el){
        var show = !q || (el.getAttribute('data-name') || '').indexOf(q) > -1;
        el.hidden = !show; if(show) n++;
      });
      if(count) count.textContent = n;
      if(empty) empty.hidden = n > 0;
    }
    if(input){ input.addEventListener('input', run); input.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ input.value = ''; run(); } }); }
    run();
  });
})();